// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen2/styles.scss
// module id = 385
// module chunks = 0